import { useEffect, useState } from "react";
import QRCode from "qrcode";

/** A plain black-on-white QR for `text`, drawn the size it is shown at. */
export function WaQr({ text, label }: { text: string; label: string }) {
  const [src, setSrc] = useState("");
  useEffect(() => {
    let stale = false;
    QRCode.toDataURL(text, { errorCorrectionLevel: "M", margin: 1, width: 392, color: { dark: "#0e1007", light: "#fbfaf8" } })
      .then((url) => {
        if (!stale) setSrc(url);
      })
      .catch(() => {
        if (!stale) setSrc("");
      });
    return () => {
      stale = true;
    };
  }, [text]);
  return src ? <img src={src} alt={label} width={196} height={196} /> : <div style={{ width: 196, height: 196 }} aria-hidden="true" />;
}
